import React from 'react'
import {KTSVG} from '../../../../../../_metronic/helpers'
import styles from './emptyInvoicesState.module.css'

export const EmptyInvoicesState = () => {
  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyIcon}>
        <KTSVG
          path='/media/icons/duotune/files/fil007.svg'
          className='svg-icon-2hx svg-icon-muted'
        />
      </div>
      <span className={styles.emptyTitle}>Nenhuma fatura encontrada</span>
      <span className={styles.emptyHint}>
        Não há faturas para os filtros selecionados. Ajuste o mês, a usina ou a unidade
        consumidora e tente novamente.
      </span>
    </div>
  )
}
